import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Login } from '@pages';
import { ProtectedLayout } from '@pages/protected-layout';
import { PathsEnum } from '@routes/enumerators/paths.enum';
import { colaboradorPagesRoutes, varejoPagesRoutes } from './pages-routes';

interface IRoutesProps {}

export const AppRoutes: React.FC<IRoutesProps> = () => (
    <Routes>
        <Route path={PathsEnum.NONE} element={<Navigate to={PathsEnum.COLABORADOR} />} />
        <Route path={PathsEnum.LOGIN} element={<Login />} />
        <Route path={PathsEnum.COLABORADOR} element={<ProtectedLayout />}>
            {colaboradorPagesRoutes()}
        </Route>
        <Route path={PathsEnum.VAREJO} element={<ProtectedLayout />}>
            {varejoPagesRoutes()}
        </Route>
        <Route path="*" element={<Navigate to={PathsEnum.NONE} />} />
    </Routes>
);
